import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { CommonModule } from '@angular/common';
import { GaugeChartComponent } from '../../client/device-detail-nxt/gauge-chart-component/gauge-chart-component.component';
import { DialogGraphscaleSettingsComponent } from '../../client/dialog-graphscale-settings/dialog-graphscale-settings.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { DialogGraphscaleVpfSettingsComponent } from '../../client/dialog-graphscale-vpf-settings/dialog-graphscale-vpf-settings.component';
@Component({
  selector: 'app-oven-gauges',
  templateUrl: './oven-gauges.component.html',
  styleUrls: ['./oven-gauges.component.scss'],
  standalone: true,
  imports: [CommonModule,GaugeChartComponent]
})
export class OvenGaugesComponent implements OnInit {
  @Output() em3PhaseCurrentValue = new EventEmitter<number>();
  public cumulativeenergyloading: boolean = true;
  public CumulativeEnergyData: any =[];
  public powerFactorStripLines=[];
  public emeterData = BaseUrlConstantsService.energyMeterApi;
  public userID: string;
  public serialNo: string;
  public dataGadge: any;
  public Itemsymbol: any;
  public gaugeShow: boolean;
  public canvasWidth = 160;
  public canvasHeight: number = 135;
  public emCumulativeEnergyLineData: any;
  public threephaseloadcurrentloading: boolean =true;
  public em3PhaseLoadCurrentData: any = [];
  public BalancingDataGadge: any;
  public em3PhaseLoadCurrentAvg:any=0;
  public em3PhaseLoadCurrentAvgPer:any=0;
  public em3PhaseLoadCurrentGreenBar:number=0;
  public em3PhaseLoadCurrentYellowBar:number=0;
  public em3PhaseLoadCurrentRedBar:number=0;
  public em3PhaseLoadCurrentGreenText:any="";
  public em3PhaseLoadCurrentYellowText:any="";
  public em3PhaseLoadCurrentRedText:any="";
  public em3PhaseLoadCurrentCol:string="";
  public em3PhaseLoadCurrentColPercentage:any="";
  public voltageStripLines=[];
  //Current
  public emCurrentLineData: any;
  public CurrentLineChartOptions="";
  public CurrentLineChartColors:any;
  public emCurrentLineMovingCount:any;
  public emCurrentLineMovingAvg:any;
  public emCurrentLineUnit:any;
  trendscurrentloading: boolean = true;

  //voltage
  //Energy Meter Screen Line Chart.
  public emVoltageLineData: any;
  public VoltageLineChartOptions="";
  public VoltageLineChartColors:any;
  public emVoltageLineMovingCount:any;
  public emVoltageLineMovingAvg:any;
  public emVoltageLineUnit:any;
  public threephaselinevoltageloading: boolean = true;
  //Enerty Meter:: Gauge :: 3 Phase Line Voltage.
  public em3PhaseLineVoltageData: any = [];
  public em3PhaseLineVoltageGreenBar:any=0;
  public em3PhaseLineVoltageYellowBar:any=0;
  public em3PhaseLineVoltageRedBar:any=0;
  
  public em3PhaseLineVoltageGreenText:any="";
  public em3PhaseLineVoltageYellowText:any="";
  public em3PhaseLineVoltageRedText:any="";
  public em3PhaseLineVoltageAvg:any=0;
  public em3PhaseLineVoltageAvgPer:any=0;
  public em3PhaseLineVoltageCol:string="";
  public em3PhaseLineVoltageColPercentage:any="";
  public trendsvoltageloading: boolean = true;
  totalharmonicdistortionloading: boolean;
  trendshtdloading: boolean;
  trendsCumulativeEnergyloading: boolean;
  powerfactorloading: boolean;
  trendspowerfactorloading: boolean;
  trendsfrequencyloading: boolean;
  peakdemandloading: boolean;
  trendskwdemandloading: boolean;
  em3phaseCorrent: any;
  public generic_asset_id: any =13;
  constructor(private service: BackendApiService,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog) {
      this.generic_asset_id = localStorage.setItem('generic_asset_id',this.generic_asset_id);
     }
    public role: any = localStorage.getItem("role");

  ngOnInit(): void {
    if(this.role === "ADMIN"){
      this.userID = localStorage.getItem("admin_client_id");
    }else{
      this.userID = localStorage.getItem("user_id");
    }
    this.generic_asset_id = localStorage.getItem('generic_asset_id');
    this.CumulativeEnergyKWH();
    this.PhaseLoadCurrent();
    this.voltageGauge();
  }

 public async CumulativeEnergyKWH(){

      //Enerty Meter:: Gauge Graph :: Cumulative Energy.
      this.service.getDataWithQuery(this.emeterData +"/cumulative-energy-v2/"+this.userID+"/"+this.generic_asset_id).then((sRes) => {

        let sensorRes= JSON.parse(JSON.stringify(sRes)).data;      
        // console.log(sensorRes)
      
        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
        
          let response = sensorRes.body;
          this.CumulativeEnergyData =[];
          if (response.sensor != undefined){
            if(response.sensor.length != 0){

              this.dataGadge= response.sensor;

              if (this.dataGadge.length !== 0) {

                let tempArr = [];
                let bottomLab = "";
              
                for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
              
                  if (JSON.parse(this.dataGadge[mCount].value) === 0 && this.dataGadge[mCount].needle === false) {

                      bottomLab = "0";
                  } else {
                    bottomLab =JSON.parse(this.dataGadge[mCount].value) <= 0 ? "0 KWH": this.dataGadge[mCount].symbol === "C" ? JSON.parse(this.dataGadge[mCount].value).toFixed(2) +
                          " °" + this.dataGadge[mCount].icon : JSON.parse(this.dataGadge[mCount].value).toFixed(2) +" " +this.dataGadge[mCount].icon;
                  }

                  this.Itemsymbol = this.dataGadge[mCount].symbol;
                  let needleValueRes;
                  if (this.dataGadge[mCount].symbol === "m/sec²") {
                    needleValueRes = (JSON.parse(this.dataGadge[mCount].value) * 100) /parseFloat(this.dataGadge[mCount].rangelabel[1]);
                  } else if (this.dataGadge[mCount].symbol === "mm/sec") {
                    needleValueRes = (JSON.parse(this.dataGadge[mCount].value) * 100) /parseFloat(this.dataGadge[mCount].rangelabel[1]);
                  } else if (this.dataGadge[mCount].symbol === "deg") {
                    needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                  } else {
                    needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                    // needleValueRes = (JSON.parse(this.dataGadge[mCount].value) * 100) / parseFloat(this.dataGadge[mCount].rangelabel[1]);
                  }
                  // console.log(`this.dataGadge[mCount].value`,this.dataGadge[mCount].value)
                  // console.log(`this.dataGadge[mCount].rangelabel[1]`,this.dataGadge[mCount].rangelabel[1])
                  // console.log(`needleValueRes`,needleValueRes)
                  let centerLab = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);
                  let arc_colors = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcColors: ["transparent", "transparent", "transparent"];
                  let range_label =this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].rangelabel: [];
                  let arc_Delimiters = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcDelimiters: [];
                  let value = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value)?.toFixed(2);

                  const CumulativeEnergyAccelerationData = {
                    needleValue: needleValueRes,
                    centralLabel: centerLab,
                    outerNeedle: false,
                    canvasWidth: 160,
                    canvasHeight:160,
                    name: this.dataGadge[mCount].name,
                    key: this.dataGadge[mCount].key,
                    bottomLabel: bottomLab,
                    hasneedle: this.dataGadge[mCount].needle,
                    options: {
                      hasNeedle: this.dataGadge[mCount].needle,
                      needleColor: "black",
                      needleUpdateSpeed: "",
                      arcColors: arc_colors,
                      arcLabels: [] as string[],
                      arcDelimiters: this.dataGadge[mCount].arcDelimiters,
                      rangeLabel: range_label,
                      needleStartValue: 0,
                    },
                  };

                  if (arc_Delimiters[0] < 100 && arc_Delimiters[0] > 0 && arc_Delimiters[1] > 0 && arc_Delimiters[0] < arc_Delimiters[1] && arc_Delimiters[1] < 100) {

                    let max = range_label[1] != null ? range_label[1] : 0;

                    CumulativeEnergyAccelerationData.options.arcLabels[0] = ((max * this.dataGadge[mCount].arcDelimiters[0]) / 100).toFixed(1).toString();
                    CumulativeEnergyAccelerationData.options.arcLabels[1] = ((max * this.dataGadge[mCount].arcDelimiters[1]) / 100).toFixed(1).toString();

                    let velocityG = this.dataGadge[mCount].arcDelimiters[0];
                    let velocityY = this.dataGadge[mCount].arcDelimiters[1];
                    let velocityR = max;

                    CumulativeEnergyAccelerationData.options.arcColors[0] = "#72FF13";
                    CumulativeEnergyAccelerationData.options.arcColors[1] = "#FAA700";
                    CumulativeEnergyAccelerationData.options.arcColors[2] = "#ff2a1b";
        
                    if (
                      CumulativeEnergyAccelerationData.centralLabel <= CumulativeEnergyAccelerationData.options.arcLabels[0]
                    ) {
                      CumulativeEnergyAccelerationData.options.needleColor = "#72FF13";
                    } else if (
                      CumulativeEnergyAccelerationData.centralLabel > CumulativeEnergyAccelerationData.options.arcLabels[0] &&
                      CumulativeEnergyAccelerationData.centralLabel <= CumulativeEnergyAccelerationData.options.arcLabels[1]
                    ) {
                      CumulativeEnergyAccelerationData.options.needleColor = "#FAA700";
                    } else {
                      CumulativeEnergyAccelerationData.options.needleColor = "#ff2a1b";
                    }
        
                    this.CumulativeEnergyData.push(CumulativeEnergyAccelerationData);
                    this.gaugeShow=true;
                  }
                
                }
                console.log(this.CumulativeEnergyData)
                if(this.CumulativeEnergyData.length >=1){                  
                  setTimeout(() => {
                    this.cumulativeenergyloading=false;
                  }, 1000);
                }
                

              }

            }
                
          }

        }

      });
    
  }

  public async PhaseLoadCurrent(){

    //Enerty Meter:: Gauge Graph :: 3 Phase Load Current.
    this.service.getDataWithQuery(this.emeterData +"/3phase-load-current/"+this.userID+"/"+this.generic_asset_id).then((sRes) => {

      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;      
    
      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
      
        let response = sensorRes.body;
        //this.threePhaseLoadCurrentSettingID = response.thresholdsID;
        this.em3PhaseLoadCurrentData =[];
        if (response.sensor != undefined){
          if(response.sensor.length != 0){
            const em3PhaseCurrentVal =  response.sensor[0].value;
            this.em3PhaseCurrentValue.emit(em3PhaseCurrentVal);
            this.dataGadge= response.sensor;

            if (this.dataGadge.length !== 0) {

              let tempArr = [];
              let bottomLab = "";
            
              for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
            
                if (JSON.parse(this.dataGadge[mCount].value) === 0 && this.dataGadge[mCount].needle === false) {

                    bottomLab = "0";
                } else {
                  bottomLab =JSON.parse(this.dataGadge[mCount].value) <= 0 ? "0 A": this.dataGadge[mCount].symbol === "C" ? JSON.parse(this.dataGadge[mCount].value).toFixed(2) +
                        " °" + this.dataGadge[mCount].icon : JSON.parse(this.dataGadge[mCount].value).toFixed(2) +" " +this.dataGadge[mCount].icon;
                }

                this.Itemsymbol = this.dataGadge[mCount].symbol;
                let needleValueRes;
                if (this.dataGadge[mCount].symbol === "m/sec²") {
                  needleValueRes = (JSON.parse(this.dataGadge[mCount].value) * 100) /parseFloat(this.dataGadge[mCount].rangelabel[1]);
                } else if (this.dataGadge[mCount].symbol === "mm/sec") {
                  needleValueRes = (JSON.parse(this.dataGadge[mCount].value) * 100) /parseFloat(this.dataGadge[mCount].rangelabel[1]);
                } else if (this.dataGadge[mCount].symbol === "deg") {
                  needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                } else {
                  //needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                  needleValueRes = (JSON.parse(this.dataGadge[mCount].value) * 100) / parseFloat(this.dataGadge[mCount].rangelabel[1]);
                }

                let centerLab = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);
                let arc_colors = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcColors: ["transparent", "transparent", "transparent"];
                let range_label =this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].rangelabel: [];
                let arc_Delimiters = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcDelimiters: [];
                let value = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value).toFixed(2);

                const em3PhaseLoadCurrentAccelerationData = {
                  value:value,
                  needleValue: needleValueRes,
                  centralLabel: centerLab,
                  outerNeedle: false,
                  canvasWidth: 150,                                                                                                                                                                                                                                         
                  name: this.dataGadge[mCount].name,
                  key: this.dataGadge[mCount].key,
                  bottomLabel: bottomLab,
                  hasneedle: this.dataGadge[mCount].needle,
                  options: {
                    hasNeedle: this.dataGadge[mCount].needle,
                    needleColor: "black",
                    needleUpdateSpeed: "",
                    arcColors: arc_colors,
                    arcLabels: [] as string[],
                    arcDelimiters: this.dataGadge[mCount].arcDelimiters,
                    rangeLabel: range_label,
                    needleStartValue: 0,
                  },
                };
                

                if (arc_Delimiters[0] < 100 && arc_Delimiters[0] > 0 && arc_Delimiters[1] > 0 && arc_Delimiters[0] < arc_Delimiters[1] && arc_Delimiters[1] < 100) {

                  let max = range_label[1] != null ? range_label[1] : 0;
                  // em3PhaseLoadCurrentAccelerationData.options.arcLabels[0] = sensorRes.body.rangeLabels.green;                    
                  // em3PhaseLoadCurrentAccelerationData.options.arcLabels[1] = sensorRes.body.rangeLabels.yellow;
                  // let velocityG = sensorRes.body.rangeLabels.green;
                  // let velocityY = sensorRes.body.rangeLabels.yellow;
                  // let velocityR = max;

                  em3PhaseLoadCurrentAccelerationData.options.arcLabels[0] = ((max * this.dataGadge[mCount].arcDelimiters[0]) / 100).toFixed(1).toString();
                  em3PhaseLoadCurrentAccelerationData.options.arcLabels[1] = ((max * this.dataGadge[mCount].arcDelimiters[1]) / 100).toFixed(1).toString();
                  //let velocityG = this.dataGadge[mCount].arcDelimiters[0];
                  //let velocityY = this.dataGadge[mCount].arcDelimiters[1];
                  //let velocityR = max;

                  em3PhaseLoadCurrentAccelerationData.options.arcColors[0] = "#72FF13";
                  em3PhaseLoadCurrentAccelerationData.options.arcColors[1] = "#FAA700";
                  em3PhaseLoadCurrentAccelerationData.options.arcColors[2] = "#ff2a1b";
      
                  if (
                    em3PhaseLoadCurrentAccelerationData.centralLabel <= em3PhaseLoadCurrentAccelerationData.options.arcLabels[0]
                  ) {
                    // accelerationData.options.centralLabel=
                    em3PhaseLoadCurrentAccelerationData.options.needleColor = "#72FF13";
                  } else if (
                    em3PhaseLoadCurrentAccelerationData.centralLabel > em3PhaseLoadCurrentAccelerationData.options.arcLabels[0] &&
                    em3PhaseLoadCurrentAccelerationData.centralLabel <= em3PhaseLoadCurrentAccelerationData.options.arcLabels[1]
                  ) {
                    em3PhaseLoadCurrentAccelerationData.options.needleColor = "#FAA700";
                  } else {
                    em3PhaseLoadCurrentAccelerationData.options.needleColor = "#ff2a1b";
                  }
      
                  this.em3PhaseLoadCurrentData.push(em3PhaseLoadCurrentAccelerationData);
                  // console.log(this.em3PhaseLoadCurrentData[0])
                  this.gaugeShow=true;
                }

                if(this.em3PhaseLoadCurrentData.length >=1){                  
                  setTimeout(() => {
                    this.threephaseloadcurrentloading=false;
                  }, 1000);
                }

               
              
              }
              
            }

          }
              
        }

        if (response.balancing != undefined){

          if(response.balancing.length != 0){
            
            this.BalancingDataGadge= response.balancing;
        
            if (this.BalancingDataGadge.length !== 0) {
              let tempArr = [];
              let bottomLab = "";
              let v1 =0;
              let v2 =0;
              let v3 =0;
              let maxValue:any=0;

              let greenRange = 0;
              let yellowRange = 0;
              let redRange = 0;
              
                            
              /******************* Load Balancing Code Start Here *****************/

              if(this.em3PhaseLoadCurrentData[0].value > 0){}else{this.em3PhaseLoadCurrentData[0].value=0.00;}
                if(this.em3PhaseLoadCurrentData[1].value > 0){}else{this.em3PhaseLoadCurrentData[1].value=0.00;}
                if(this.em3PhaseLoadCurrentData[2].value > 0){}else{this.em3PhaseLoadCurrentData[2].value=0.00;}

                let Total:number = parseFloat(this.em3PhaseLoadCurrentData[0].value) + parseFloat(this.em3PhaseLoadCurrentData[1].value) + parseFloat(this.em3PhaseLoadCurrentData[2].value);

                this.em3PhaseLoadCurrentAvg = Total/3;
                if(this.BalancingDataGadge[0].threshold_1 >0 && this.BalancingDataGadge[0].threshold_2 >0 && this.BalancingDataGadge[0].threshold_3 >0 && this.BalancingDataGadge[0].max_value >0 ){
        
                  v1=this.em3PhaseLoadCurrentData[0].value-this.em3PhaseLoadCurrentAvg;
                  v2=this.em3PhaseLoadCurrentData[1].value-this.em3PhaseLoadCurrentAvg;
                  v3=this.em3PhaseLoadCurrentData[2].value-this.em3PhaseLoadCurrentAvg;
                                                                                                                                                                                                                                                            maxValue = Math.max(v1, v2, v3);
                  
                  this.em3PhaseLoadCurrentAvg=(maxValue*100)/this.em3PhaseLoadCurrentAvg;  
                  this.em3PhaseLoadCurrentAvgPer=this.em3PhaseLoadCurrentAvg;
                  this.em3PhaseLoadCurrentAvg = (this.em3PhaseLoadCurrentAvg*100)/this.BalancingDataGadge[0].max_value;

                  this.em3PhaseLoadCurrentGreenBar=this.BalancingDataGadge[0].threshold_1;
                  this.em3PhaseLoadCurrentYellowBar=this.BalancingDataGadge[0].threshold_2;
                  this.em3PhaseLoadCurrentRedBar = (100-(this.BalancingDataGadge[0].threshold_2+this.BalancingDataGadge[0].threshold_1));
                  
                  this.em3PhaseLoadCurrentGreenText=(this.BalancingDataGadge[0].threshold_1*this.BalancingDataGadge[0].max_value)/100;
                  this.em3PhaseLoadCurrentYellowText=((this.BalancingDataGadge[0].threshold_2+this.BalancingDataGadge[0].threshold_1)*this.BalancingDataGadge[0].max_value)/100;
                  this.em3PhaseLoadCurrentRedText = ((this.BalancingDataGadge[0].threshold_3+this.BalancingDataGadge[0].threshold_2+this.BalancingDataGadge[0].threshold_1)*this.BalancingDataGadge[0].max_value)/100;


                  greenRange = this.BalancingDataGadge[0].threshold_1;
                  yellowRange = this.BalancingDataGadge[0].threshold_1+this.BalancingDataGadge[0].threshold_2;
                  redRange = this.BalancingDataGadge[0].threshold_1+this.BalancingDataGadge[0].threshold_2+this.BalancingDataGadge[0].threshold_3;

                  if(this.em3PhaseLoadCurrentAvg > 0 && this.em3PhaseLoadCurrentAvg <= greenRange){
        
                    this.em3PhaseLoadCurrentCol = 'green';
                    this.em3PhaseLoadCurrentAvg = ((this.em3PhaseLoadCurrentAvg*100)/this.BalancingDataGadge[0].threshold_1).toFixed(2);
        
                  }else if(this.em3PhaseLoadCurrentAvg >= greenRange && this.em3PhaseLoadCurrentAvg <= yellowRange){
        
                    this.em3PhaseLoadCurrentCol = 'yellow';
                    this.em3PhaseLoadCurrentAvg =  this.em3PhaseLoadCurrentAvg-this.BalancingDataGadge[0].threshold_1;
                    this.em3PhaseLoadCurrentAvg =  (this.em3PhaseLoadCurrentAvg*100)/this.BalancingDataGadge[0].threshold_2; 
                  }else if(this.em3PhaseLoadCurrentAvg >= greenRange && this.em3PhaseLoadCurrentAvg <= redRange){
        
                    this.em3PhaseLoadCurrentCol = 'red';                    
                    this.em3PhaseLoadCurrentAvg = this.em3PhaseLoadCurrentAvg-yellowRange;
                    this.em3PhaseLoadCurrentAvg = (this.em3PhaseLoadCurrentAvg*100)/this.BalancingDataGadge[0].threshold_3;
                   
                  }else{
                    if(this.em3PhaseLoadCurrentAvg > 0){
                      
                      this.em3PhaseLoadCurrentCol = 'red';                        
                      this.em3PhaseLoadCurrentAvg='100';

                    }else{

                      this.em3PhaseLoadCurrentCol = '';

                    }
                    
                  }
        
                }else{
                  this.em3PhaseLoadCurrentCol = ''; 
                }
              /******************* Ooad Balancing Code End Here *******************/
        
        
            }
            
          }
        }

      }

    });

    //Enerty Meter:: Line Graph :: Current.      
    this.service.getDataWithQuery(this.emeterData+'/trends-current/'+this.userID+"/"+this.generic_asset_id+"/hour").then((sRes) => {
      
      let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

        let response = sensorRes.body;
        this.emCurrentLineData =[];
        this.CurrentLineChartColors =[];

        this.CurrentLineChartOptions = response.name;
        this.emCurrentLineUnit = response.symbol;

          if (response.sensor != undefined){

            if(response.sensor.length != 0){
              let barData= response.sensor;
              this.emCurrentLineData.push(barData);              
            }

            if(response.rangeLabels.length != 0){              
              this.CurrentLineChartColors.push(response.rangeLabels);
            }
            
            if(this.CurrentLineChartColors.length >=1 || this.emCurrentLineData.length >=1){                  
              setTimeout(() => {
                this.trendscurrentloading=false;
              }, 1000);
            }        

          }

          if(response.movingAvg != undefined){

            if(response.movingAvg.length != 0){

                this.emCurrentLineMovingAvg = response.movingAvg;
                this.emCurrentLineMovingCount = response.movingCount;
            }
          }
      }

    });

}

public async getEmeterGraphScaleSettingsDataByID(metric_type: string, generic_asset_id: string): Promise<any> {
  try {
    const sensorRes = await this.service.getDataWithQuery(`${this.emeterData}/emeter-graph-scale-settings/${metric_type}/${generic_asset_id}`).then(res =>{
      return res;
    });
    const sensorBody = JSON.parse(JSON.stringify(sensorRes)).data.body;

    if (sensorBody && Object.keys(sensorBody).length !== 0) {
      return sensorBody;
    } else {
      throw new Error('No data found in sensor response');
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error; // Rethrow the error to be handled by the caller
  }
}

async saveSettings(updatedSettings: any):Promise<boolean> {
  // Implement saving logic using DataService
  // Example:
  return await this.service.saveSettings(this.emeterData+"/emeter-graph-scale-settings-save?generic_asset_id="+this.generic_asset_id,updatedSettings).then((sRes) => {
  // return await this.service.saveSettings("http://localhost:3105/emeter/emeter-graph-scale-settings-save?serialNo="+this.serialNo,updatedSettings).then((sRes) => {
    return true;
  }, error => {
    console.error('Error saving settings:', error);
    return false;
  }).catch(()=>{return false});
}


// public async PhaseLineVoltage(){


//   //Enerty Meter:: Line Graph :: voltage.      
//    this.service.getDataWithQuery(this.emeterData+'/trends-voltage/'+this.userID+"/"+this.serialNo+"/hour").then((sRes) => {
    
//     let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

//     if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

//       let response = sensorRes.body;
//       // console.log(response)
//       this.emVoltageLineData =[];
//       this.VoltageLineChartColors =[];

//       this.VoltageLineChartOptions = response.name;
//       this.emVoltageLineUnit = response.symbol;

//         if (response.sensor != undefined){

//           if(response.sensor.length != 0){
//             let barData= response.sensor;
//             this.emVoltageLineData.push(barData);              
//           }

//           if(response.rangeLabels.length != 0){              
//             this.VoltageLineChartColors.push(response.rangeLabels);
//           }
          
//           if(this.emVoltageLineData.length >=1 || this.VoltageLineChartColors.length >=1){                  
//             // setTimeout(() => {
//               this.trendsvoltageloading=false;
//             // }, 1000);
//           }
//           if(response.rangeLabels){
//             let {min_value,max_value,threshold_1,threshold_2,orieX_default,orieY_default} = response.rangeLabels
//             // let arcs=em3PhaseLineVoltageAccelerationData.options.arcLabels;
//             // let range=em3PhaseLineVoltageAccelerationData.options.rangeLabel;
//             this.voltageStripLines=[];
//             // this.voltageStripLines.push(Number(range[0]))
//             // this.voltageStripLines.push(Number(arcs[0]))
//             // this.voltageStripLines.push(Number(arcs[1]))
//             // this.voltageStripLines.push(Number(arcs[2]))
//             // this.voltageStripLines.push(Number(arcs[3]))
//             // this.voltageStripLines.push(Number(arcs[4]))
//             // this.voltageStripLines.push(Number(arcs[5]))
//             // this.voltageStripLines.push(Number(range[1]))
//             this.voltageStripLines.push(min_value,threshold_1,threshold_2,orieX_default,orieY_default,max_value)
//         }
//         }

//         if(response.movingAvg != undefined){

//           if(response.movingAvg.length != 0){

//               this.emVoltageLineMovingAvg = response.movingAvg;
//               this.emVoltageLineMovingCount = response.movingCount;
//           }
//         }


//     }

//   });
// //   let graphInterval2=setInterval(()=>{
// //     if((this.emVoltageLineData.length >=1 || this.VoltageLineChartColors.length >=1) && this.em3PhaseLineVoltageData.length >=1){                  
// //       this.trendsvoltageloading=false;
// //       this.threephaselinevoltageloading=false;
// //       clearInterval(graphInterval2)
// //   }
// // },2000)
// }


 voltageGauge(){
          //Enerty Meter:: Gauge Graph :: 3 Phase Line Voltage.
          this.service.getDataWithQuery(this.emeterData +"/3phase-line-voltage/"+this.userID+"/"+this.generic_asset_id).then((sRes) => {

            let sensorRes= JSON.parse(JSON.stringify(sRes)).data;      
          
            if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
            
              let response = sensorRes.body;
              //this.threePhaseLineVoltageSettingID = response.thresholdsID;
              this.em3PhaseLineVoltageData =[];
              if (response.sensor != undefined){
                if(response.sensor.length != 0){
    
                  this.dataGadge= response.sensor;
    
                  if (this.dataGadge.length !== 0) {
                    let tempArr = [];
                    let bottomLab = "";
                  
                    for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
                  
                      if (JSON.parse(this.dataGadge[mCount].value) === 0 && this.dataGadge[mCount].needle === false) {
    
                          bottomLab = "N/A";
                      } else {
                        bottomLab =JSON.parse(this.dataGadge[mCount].value) <= 0 ? "N/A": this.dataGadge[mCount].symbol === "C" ? JSON.parse(this.dataGadge[mCount].value).toFixed(2)+
                              " °" + this.dataGadge[mCount].icon : JSON.parse(this.dataGadge[mCount].value).toFixed(2) +" " +this.dataGadge[mCount].icon;
                      }
    
                      this.Itemsymbol = this.dataGadge[mCount].symbol;
                      let centerLab = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value);
                      let arc_colors = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcColors: ["transparent", "transparent", "transparent"];
                      let range_label =this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].rangelabel: [];
                      let arc_Delimiters = this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].arcDelimiters: [];
                      let value = JSON.parse(this.dataGadge[mCount].value) < 0 ? "N/A": JSON.parse(this.dataGadge[mCount].value).toFixed(2);
    
                      /***********my new logic start for new gauge chart for PF***********/                  
                      let RedUnderVal=0;
                      let yellowUnderVal=0;
                      let GreenUnderVal=0;
                      let greenOverVal=0;
                      let yellowOverVal=0;
                      let rangeDiffrence=0;                                   
    
                      if(range_label.length === 2){                  
                        
                        RedUnderVal =  parseFloat(arc_Delimiters[0]);
                        yellowUnderVal =  parseFloat(arc_Delimiters[1]);
                        GreenUnderVal = parseFloat(arc_Delimiters[2]);
                        greenOverVal =  parseFloat(arc_Delimiters[3]);
                        yellowOverVal =  parseFloat(arc_Delimiters[4]);
                        rangeDiffrence = (parseFloat(range_label[1])-parseFloat(range_label[0]));
                       
                      }
                      
                      let arc_Delimiters_values =[];
    
                      //1st value. 
                      let FirstVal = 0;
                      FirstVal = (RedUnderVal-parseFloat(range_label[0])); 
                      FirstVal = ((FirstVal*100)/rangeDiffrence);           
                      arc_Delimiters_values.push(FirstVal);
    
                      //2nd value.                   
                      let SecondsVal = 0;
                      SecondsVal = (yellowUnderVal-parseFloat(range_label[0])); 
                      SecondsVal = ((SecondsVal*100)/rangeDiffrence);           
                      arc_Delimiters_values.push(SecondsVal);
    
                      //3rd value.
                      let thirdVal = 0;
                      thirdVal = (GreenUnderVal-parseFloat(range_label[0])); 
                      thirdVal = ((thirdVal*100)/rangeDiffrence);           
                      arc_Delimiters_values.push(thirdVal);
    
                      //4th value. 
                      let FourthVal = 0;
                      FourthVal = (greenOverVal-parseFloat(range_label[0])); 
                      FourthVal = ((FourthVal*100)/rangeDiffrence);           
                      arc_Delimiters_values.push(FourthVal);
    
                      //5th value. 
                      let FifthVal = 0;
                      FifthVal = (yellowOverVal-parseFloat(range_label[0])); 
                      FifthVal = ((FifthVal*100)/rangeDiffrence);           
                      arc_Delimiters_values.push(FifthVal);
                      
    
                      let needleVal = 0;
                      let needleMinPercentage = 0;
                      let needleMinValue = 0;
                      let needleMaxPercentage = 0;                  
                      let needleMaxValue = 0;
                      let percentage = 0;
    
                      needleVal = this.dataGadge[mCount].value;
    
                      
                      //Update needleValueRes.
                      if(this.dataGadge[mCount].value <=RedUnderVal){
    
                        needleMinValue = 0;
                        needleMaxValue = RedUnderVal;
                        needleMinPercentage = 0;
                        needleMaxPercentage = arc_Delimiters_values[0];
                        percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
    
                      }else if(needleVal >= RedUnderVal && needleVal <= yellowUnderVal){
    
                        needleMinValue = RedUnderVal;
                        needleMaxValue = yellowUnderVal;
                        needleMinPercentage = arc_Delimiters_values[0];
                        needleMaxPercentage = arc_Delimiters_values[1];
                        percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
                        
                      }else if(needleVal >= yellowUnderVal && needleVal <= GreenUnderVal){
    
                        needleMinValue = yellowUnderVal;
                        needleMaxValue = GreenUnderVal;
                        needleMinPercentage = arc_Delimiters_values[1];
                        needleMaxPercentage = arc_Delimiters_values[2];
                        percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
    
                      }else if(needleVal >= GreenUnderVal && needleVal <= greenOverVal){
    
                        needleMinValue = GreenUnderVal;
                        needleMaxValue = greenOverVal;
                        needleMinPercentage = arc_Delimiters_values[2];
                        needleMaxPercentage = arc_Delimiters_values[3];
                        percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
    
                      }else if(needleVal >= greenOverVal && needleVal <= yellowOverVal){
    
                        needleMinValue = greenOverVal;
                        needleMaxValue = yellowOverVal;
                        needleMinPercentage = arc_Delimiters_values[3];
                        needleMaxPercentage = arc_Delimiters_values[4];
                        percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
    
                      }else{
    
                        needleMinValue = yellowOverVal;
                        needleMaxValue = range_label[1];
                        needleMinPercentage = arc_Delimiters_values[4];
                        needleMaxPercentage = arc_Delimiters_values[5];
                        percentage = needleMinPercentage+((needleVal-needleMinValue)/(needleMaxValue-needleMinValue))*(needleMaxPercentage-needleMinPercentage);
    
                      }
    
                      /***********my new logic end here for new gauge chart for PF***********/
    
    
    
                      const em3PhaseLineVoltageAccelerationData = {
                        value:value,
                        needleValue: needleVal,
                        centralLabel: centerLab,
                        outerNeedle: false,
                        canvasWidth: 150,
                        name: this.dataGadge[mCount].name,
                        key: this.dataGadge[mCount].key,
                        bottomLabel: bottomLab,
                        hasneedle: this.dataGadge[mCount].needle,
                        options: {
                          hasNeedle: this.dataGadge[mCount].needle,
                          needleColor: "black",
                          needleUpdateSpeed: "",
                          arcColors: arc_colors,
                          arcLabels: [] as string[],
                          arcDelimiters: arc_Delimiters_values,
                          rangeLabel: range_label,
                          needleStartValue: 0,
                        },
                      };
    
                      if (arc_Delimiters_values[0] < 100 && arc_Delimiters_values[0] > 0 && arc_Delimiters_values[1] > 0 && arc_Delimiters_values[0] < arc_Delimiters_values[1] && arc_Delimiters_values[1] < 100) {
                        
                        
                        
                        //*******************************************************************************
                        let max = range_label[1] != null ? range_label[1] : 0;
                                           
                        em3PhaseLineVoltageAccelerationData.options.arcLabels[0] = (RedUnderVal).toFixed(0).toString();
                        em3PhaseLineVoltageAccelerationData.options.arcLabels[1] = (yellowUnderVal).toFixed(1).toString();
                        // em3PhaseLineVoltageAccelerationData.options.arcLabels[2] = (GreenUnderVal).toFixed(1).toString(); // commented to hide additonal mid green label
                        em3PhaseLineVoltageAccelerationData.options.arcLabels[3] = (greenOverVal).toFixed(1).toString();
                        em3PhaseLineVoltageAccelerationData.options.arcLabels[4] = (yellowOverVal).toFixed(1).toString();
                       
                        em3PhaseLineVoltageAccelerationData.options.arcColors[0] = "#ff2a1b";
                        em3PhaseLineVoltageAccelerationData.options.arcColors[1] = "#FAA700";
                        em3PhaseLineVoltageAccelerationData.options.arcColors[2] = "#72FF13";
                        em3PhaseLineVoltageAccelerationData.options.arcColors[3] = "#72FF13";
                        em3PhaseLineVoltageAccelerationData.options.arcColors[4] = "#FAA700";
                        em3PhaseLineVoltageAccelerationData.options.arcColors[5] = "#ff2a1b";
            
                        if (
                          em3PhaseLineVoltageAccelerationData.centralLabel <= em3PhaseLineVoltageAccelerationData.options.arcLabels[0]
                        ) {
                          // accelerationData.options.centralLabel=
                          em3PhaseLineVoltageAccelerationData.options.needleColor = "#ff2a1b";
                        } else if (
                          em3PhaseLineVoltageAccelerationData.centralLabel > em3PhaseLineVoltageAccelerationData.options.arcLabels[0] &&
                          em3PhaseLineVoltageAccelerationData.centralLabel <= em3PhaseLineVoltageAccelerationData.options.arcLabels[1]
                        ) {
                          em3PhaseLineVoltageAccelerationData.options.needleColor = "#FAA700";
                        } else if (
                          em3PhaseLineVoltageAccelerationData.centralLabel > em3PhaseLineVoltageAccelerationData.options.arcLabels[1] &&
                          em3PhaseLineVoltageAccelerationData.centralLabel <= em3PhaseLineVoltageAccelerationData.options.arcLabels[2]
                        ){
    
                          em3PhaseLineVoltageAccelerationData.options.needleColor = "#72FF13";
                        }else if (
                          em3PhaseLineVoltageAccelerationData.centralLabel > em3PhaseLineVoltageAccelerationData.options.arcLabels[2] &&
                          em3PhaseLineVoltageAccelerationData.centralLabel <= em3PhaseLineVoltageAccelerationData.options.arcLabels[3]
                        ){
                          em3PhaseLineVoltageAccelerationData.options.needleColor = "#72FF13";
                        }else if (
                          em3PhaseLineVoltageAccelerationData.centralLabel > em3PhaseLineVoltageAccelerationData.options.arcLabels[3] &&
                          em3PhaseLineVoltageAccelerationData.centralLabel <= em3PhaseLineVoltageAccelerationData.options.arcLabels[4]
                        ){
                          em3PhaseLineVoltageAccelerationData.options.needleColor = "#FAA700";
                        }else{
                          em3PhaseLineVoltageAccelerationData.options.needleColor = "#ff2a1b";
                        }
                        if(em3PhaseLineVoltageAccelerationData.options.arcLabels.length && em3PhaseLineVoltageAccelerationData.options.rangeLabel.length){
                          let arcs=em3PhaseLineVoltageAccelerationData.options.arcLabels;
                          let range=em3PhaseLineVoltageAccelerationData.options.rangeLabel;
                          this.voltageStripLines=[];
                          this.voltageStripLines.push(Number(range[0]))
                          this.voltageStripLines.push(Number(arcs[0]))
                          this.voltageStripLines.push(Number(arcs[1]))
                          // this.voltageStripLines.push(Number(arcs[2]))
                          this.voltageStripLines.push(Number(arcs[3]))
                          this.voltageStripLines.push(Number(arcs[4]))
                          // this.voltageStripLines.push(Number(arcs[5]))
                          this.voltageStripLines.push(Number(range[1]))
                          // this.em3PhaseLineVoltageData.voltageStripLines=voltageStripLines
                      }
                        //*******************************************************************************
                                
                        this.em3PhaseLineVoltageData.push(em3PhaseLineVoltageAccelerationData);
                        this.gaugeShow=true;
                      }
                      console.log(this.em3PhaseLineVoltageData);
                      if(this.em3PhaseLineVoltageData.length >=1){                  
                        setTimeout(() => {
                        this.threephaselinevoltageloading=false;
                        }, 1000);
                      }
                    
                    }
    
                  }
    
                }
                    
              }
    
              if (response.balancing != undefined){
    
                if(response.balancing.length != 0){
                  
                  this.BalancingDataGadge= response.balancing;
              
                  if (this.BalancingDataGadge.length !== 0) {
                    let tempArr = [];
                    let bottomLab = "";
                    let v1 =0;
                    let v2 =0;
                    let v3 =0;
                    let maxValue:any=0;
    
                    let greenRange = 0;
                    let yellowRange = 0;
                    let redRange = 0;
                    
                                  
                    if(parseFloat(this.em3PhaseLineVoltageData[0].value) > 0 && parseFloat(this.em3PhaseLineVoltageData[1].value) > 0 && parseFloat(this.em3PhaseLineVoltageData[2].value) > 0){
    
                      var Total:number = parseFloat(this.em3PhaseLineVoltageData[0].value) + parseFloat(this.em3PhaseLineVoltageData[1].value) + parseFloat(this.em3PhaseLineVoltageData[2].value);
    
                      this.em3PhaseLineVoltageAvg = Total/3;
    
                      if(this.BalancingDataGadge[0].threshold_1 >0 && this.BalancingDataGadge[0].threshold_2 >0 && this.BalancingDataGadge[0].threshold_3 >0 && this.BalancingDataGadge[0].max_value >0 ){
    
                        if(this.em3PhaseLineVoltageData[0].value > 0){
                          v1=this.em3PhaseLineVoltageData[0].value-this.em3PhaseLineVoltageAvg;
                        }else{
                          v1=0.0;
                        }
                        
                        if(this.em3PhaseLineVoltageData[1].value > 0 ){
                          v2=this.em3PhaseLineVoltageData[1].value-this.em3PhaseLineVoltageAvg;
                        }else{
                          v2=0;
                        }
                        
                        if(this.em3PhaseLineVoltageData[2].value >0){
                          v3=this.em3PhaseLineVoltageData[2].value-this.em3PhaseLineVoltageAvg;
                        }else{
                          v3=0;
                        }
                        
                        maxValue = Math.max(v1, v2, v3);
                        
                        this.em3PhaseLineVoltageAvg=(maxValue*100)/this.em3PhaseLineVoltageAvg;  
                        this.em3PhaseLineVoltageAvgPer=this.em3PhaseLineVoltageAvg;
                        this.em3PhaseLineVoltageAvg = (this.em3PhaseLineVoltageAvg*100)/this.BalancingDataGadge[0].max_value;
    
                        this.em3PhaseLineVoltageGreenBar=this.BalancingDataGadge[0].threshold_1;
                        this.em3PhaseLineVoltageYellowBar=this.BalancingDataGadge[0].threshold_2;
                        this.em3PhaseLineVoltageRedBar = (100-(this.BalancingDataGadge[0].threshold_2+this.BalancingDataGadge[0].threshold_1));
                        
                        this.em3PhaseLineVoltageGreenText=(this.BalancingDataGadge[0].threshold_1*this.BalancingDataGadge[0].max_value)/100;
                        this.em3PhaseLineVoltageYellowText=((this.BalancingDataGadge[0].threshold_2+this.BalancingDataGadge[0].threshold_1)*this.BalancingDataGadge[0].max_value)/100;
                        this.em3PhaseLineVoltageRedText = ((this.BalancingDataGadge[0].threshold_3+this.BalancingDataGadge[0].threshold_2+this.BalancingDataGadge[0].threshold_1)*this.BalancingDataGadge[0].max_value)/100;
    
    
                        greenRange = this.BalancingDataGadge[0].threshold_1;
                        yellowRange = this.BalancingDataGadge[0].threshold_1+this.BalancingDataGadge[0].threshold_2;
                        redRange = this.BalancingDataGadge[0].threshold_1+this.BalancingDataGadge[0].threshold_2+this.BalancingDataGadge[0].threshold_3;
    
                        if(this.em3PhaseLineVoltageAvg > 0 && this.em3PhaseLineVoltageAvg <= greenRange){
    
                          this.em3PhaseLineVoltageCol = 'green';
                          this.em3PhaseLineVoltageAvg = ((this.em3PhaseLineVoltageAvg*100)/this.BalancingDataGadge[0].threshold_1).toFixed(2);
    
                        }else if(this.em3PhaseLineVoltageAvg >= greenRange && this.em3PhaseLineVoltageAvg <= yellowRange){
    
                          this.em3PhaseLineVoltageCol = 'yellow';
                          this.em3PhaseLineVoltageAvg =  this.em3PhaseLineVoltageAvg-this.BalancingDataGadge[0].threshold_1;
                          this.em3PhaseLineVoltageAvg =  (this.em3PhaseLineVoltageAvg*100)/this.BalancingDataGadge[0].threshold_2; 
    
                        }else if(this.em3PhaseLineVoltageAvg >= greenRange && this.em3PhaseLineVoltageAvg <= redRange){
    
                          this.em3PhaseLineVoltageCol = 'red';                    
                          this.em3PhaseLineVoltageAvg = this.em3PhaseLineVoltageAvg-yellowRange;
                          this.em3PhaseLineVoltageAvg = (this.em3PhaseLineVoltageAvg*100)/this.BalancingDataGadge[0].threshold_3;
                          
                        }else{
    
                          if(this.em3PhaseLineVoltageAvg > 0){
                            
                            this.em3PhaseLineVoltageCol = 'red';                        
                            this.em3PhaseLineVoltageAvg='100';
    
                          }else{
    
                            this.em3PhaseLineVoltageCol = '';
    
                          }
                        
                        }
    
                      }
    
                    }else{          
                      this.em3PhaseLineVoltageCol = '';
                    }
              
              
                  }
                  
                }
              }
    
            }
    
          });
  }
  openEmeterGraphSettingsDialog(metric_type: string, generic_asset_id: string): void {
      // Open Dialog Box with loading state
      const dialogRef = this.dialog.open(DialogGraphscaleSettingsComponent, {
        width: '800px',
        data: { loading: true } // Initial data with loading state
      });
    
      // Fetch data
      this.getEmeterGraphScaleSettingsDataByID(metric_type, generic_asset_id).then((data: any) => {
        // Prepare the data
        const response = data;
        // const graphScaleSettingData = {
        //   metric_type: metric_type,
        //   id: thresholdID,
        //   green: response.threshold_1,
        //   yellow: response.threshold_2,
        //   red: response.threshold_3,
        //   max_value: response.max_value,
        //   min_value: response.base_value
        // };
    
        // Update dialog data
        dialogRef.componentInstance.updateData(response);
      }).catch(error => {
        console.error('Error fetching data:', error);
        // Handle error here
      });
    
      // Handle dialog close event
      dialogRef.afterClosed().subscribe(async updatedSettings => {
        if (updatedSettings) {
  
          const isSuccess=await this.saveSettings(updatedSettings);  
          var currentSettingRequest = updatedSettings[0].metric_type;
          // console.log("CURRENT SETTING ",currentSettingRequest)
  
          if (currentSettingRequest === '3PhaseLoadCurrentA') {
            this.threephaseloadcurrentloading = true;
            this.trendscurrentloading = true;
            setTimeout(() => {
              this.PhaseLoadCurrent();
            }, 2000);
          }  
          if (currentSettingRequest === '3PhaseLineVoltageA') {
            this.threephaselinevoltageloading = true;
            this.trendsvoltageloading = true;
            setTimeout(() => {
              this.voltageGauge();
            }, 2000);
          }
          // if (currentSettingRequest === 'TotalHarmonicDistortionA') {
          //   this.totalharmonicdistortionloading = true;
          //   this.trendshtdloading = true;
          //   setTimeout(() => {
          //     this.TotalHarmonicDistortion();
          //   }, 2000);
          // }
          if (currentSettingRequest === 'CumulativeEnergyA' && isSuccess) {
            setTimeout(() => {
              this.CumulativeEnergyKWH();
            }, 2000);
          }
          if (currentSettingRequest === 'CumulativeEnergyA') {
            this.cumulativeenergyloading = true;
            this.trendsCumulativeEnergyloading = true;
          }
          // if (currentSettingRequest === 'PowerFactor') {
          //   this.powerfactorloading = true;
          //   this.trendspowerfactorloading = true;
          //   this.trendsfrequencyloading = true;
          //   setTimeout(() => {
          //     this.PowerFactorFrequency();
          //   }, 0);
          // }
          
          // if (currentSettingRequest === 'PeakDemand-KW') {
          //   this.peakdemandloading = true;
          //   this.trendskwdemandloading = true;
          //   setTimeout(() => {
          //     this.PeakDemandKWKVA();
          //   }, 2000);
          // }
          
    
          // Show toast message
          this._snackBar.open('Settings have been saved successfully.', 'Dismiss', {
            duration: 2000,
            horizontalPosition: 'center',
            verticalPosition: 'center' as MatSnackBarVerticalPosition, // Explicitly specify the type
            panelClass: ['custom-snackbar']
          });
        }
      });
    }

    public async getEmeterVpfGraphScaleSettingsDataByID(metric_type: string, serial_number: string): Promise<any> {
    try {
      const sensorRes = await this.service.getDataWithQuery(`${this.emeterData}/emeter-graph-scale-vpf-settings/${metric_type}/${serial_number}`).then(res =>{
        return res;
      });
      const sensorBody = JSON.parse(JSON.stringify(sensorRes)).data.body;
  
      if (sensorBody && Object.keys(sensorBody).length !== 0) {
        return sensorBody;
      } else {
        throw new Error('No data found in sensor response');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error; // Rethrow the error to be handled by the caller
    }
  }

  saveVpfSettings(updatedSettings: any): void {
    // Implement saving logic using DataService
    // Example:
    this.service.saveSettings(this.emeterData+"/emeter-graph-scale-vpf-settings-save",updatedSettings).then((sRes) => {
        // console.log(sRes,'gesug')
    }, error => {
      console.error('Error saving settings:', error);
    });
  }


  public async PhaseLineVoltage(){


      //Enerty Meter:: Line Graph :: voltage.      
       this.service.getDataWithQuery(this.emeterData+'/trends-voltage/'+this.userID+"/"+this.generic_asset_id+"/hour").then((sRes) => {
        
        let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

          let response = sensorRes.body;
          // console.log(response)
          this.emVoltageLineData =[];
          this.VoltageLineChartColors =[];

          this.VoltageLineChartOptions = response.name;
          this.emVoltageLineUnit = response.symbol;

            if (response.sensor != undefined){

              if(response.sensor.length != 0){
                let barData= response.sensor;
                this.emVoltageLineData.push(barData);              
              }

              if(response.rangeLabels.length != 0){              
                this.VoltageLineChartColors.push(response.rangeLabels);
              }
              
              if(this.emVoltageLineData.length >=1 || this.VoltageLineChartColors.length >=1){                  
                // setTimeout(() => {
                  this.trendsvoltageloading=false;
                // }, 1000);
              }
              if(response.rangeLabels){
                let {min_value,max_value,threshold_1,threshold_2,orieX_default,orieY_default} = response.rangeLabels
                // let arcs=em3PhaseLineVoltageAccelerationData.options.arcLabels;
                // let range=em3PhaseLineVoltageAccelerationData.options.rangeLabel;
                this.voltageStripLines=[];
                // this.voltageStripLines.push(Number(range[0]))
                // this.voltageStripLines.push(Number(arcs[0]))
                // this.voltageStripLines.push(Number(arcs[1]))
                // this.voltageStripLines.push(Number(arcs[2]))
                // this.voltageStripLines.push(Number(arcs[3]))
                // this.voltageStripLines.push(Number(arcs[4]))
                // this.voltageStripLines.push(Number(arcs[5]))
                // this.voltageStripLines.push(Number(range[1]))
                this.voltageStripLines.push(min_value,threshold_1,threshold_2,orieX_default,orieY_default,max_value)
            }
            }

            if(response.movingAvg != undefined){

              if(response.movingAvg.length != 0){

                  this.emVoltageLineMovingAvg = response.movingAvg;
                  this.emVoltageLineMovingCount = response.movingCount;
              }
            }


        }

      });
    //   let graphInterval2=setInterval(()=>{
    //     if((this.emVoltageLineData.length >=1 || this.VoltageLineChartColors.length >=1) && this.em3PhaseLineVoltageData.length >=1){                  
    //       this.trendsvoltageloading=false;
    //       this.threephaselinevoltageloading=false;
    //       clearInterval(graphInterval2)
    //   }
    // },2000)
  }
  // public async PowerFactorFrequency(){


  //     //Enerty Meter:: Line Graph :: Current.      
  //      this.service.getDataWithQuery(this.emeterData+'/trends-frequency/'+this.userID+"/"+this.serialNo+"/hour").then((sRes) => {
        
  //       let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

  //       if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

  //         let response = sensorRes.body;
  //         this.emFrequencyLineData =[];
  //         this.FrequencyLineChartColors =[];

  //         this.FrequencyLineChartOptions = response.name;
  //         this.emFrequencyLineUnit = response.symbol;
          

  //           if (response.sensor != undefined){

  //             if(response.sensor.length != 0){
  //               let barData= response.sensor;
  //               this.emFrequencyLineData.push(barData);              
  //             }

  //             if(response.rangeLabels.length != 0){              
  //               this.FrequencyLineChartColors.push(response.rangeLabels);
  //             }
              
  //             if(this.emFrequencyLineData.length >=1 || this.FrequencyLineChartColors.length >=1){                  
  //               setTimeout(() => {
  //                 this.trendsfrequencyloading=false;
  //               }, 1000);
  //             } 

  //             if(response.rangeLabels){
  //               let {min_value,max_value,threshold_1,threshold_2,orieX_default,orieY_default} = response.rangeLabels
  //               this.frequencyStripLines.push(min_value,threshold_1,threshold_2,orieX_default,orieY_default,max_value)
  //             }

  //           }

  //           if(response.movingAvg != undefined){

  //             if(response.movingAvg.length != 0){
  
  //                 this.emFrequencyMovingAvg = response.movingAvg;
  //                 this.emFrequencyMovingCount = response.movingCount;
  //             }
  //           }
  //       }

  //     });

  //     //Enerty Meter:: Line Graph :: Power Factor.      
  //      this.service.getDataWithQuery(this.emeterData+'/trends-power-factor/'+this.userID+"/"+this.serialNo+"/hour").then((sRes) => {
        
  //       let sensorRes= JSON.parse(JSON.stringify(sRes)).data;

  //       if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {

  //         let response = sensorRes.body;
  //         this.emPowerFactorLineData =[];
  //         this.PowerFactorLineChartColors =[];

  //         this.PowerFactorLineChartOptions = response.name;
  //         this.emPowerFactorLineUnit = response.symbol;

  //           if (response.sensor != undefined){

  //             if(response.sensor.length != 0){
  //               let barData= response.sensor;
  //               this.emPowerFactorLineData.push(barData);              
  //             }

  //             if(response.rangeLabels.length != 0){              
  //               this.PowerFactorLineChartColors.push(response.rangeLabels);
  //             }
              
  //             if(this.emPowerFactorLineData.length >=1 || this.PowerFactorLineChartColors.length >=1){                  
  //               setTimeout(() => {
  //                 this.trendspowerfactorloading=false;
  //               }, 1000);
  //             } 
  //             if(response.rangeLabels){
  //               let {min_value,max_value,threshold_1,threshold_2,orieX_default,orieY_default} = response.rangeLabels
  //               this.powerFactorStripLines.push(min_value,threshold_1,threshold_2,orieX_default,orieY_default,max_value)
  //                 // let arcs=emPowerFactorFrequencyAccelerationData.options.arcLabels;
  //                 // let range=emPowerFactorFrequencyAccelerationData.options.rangeLabel;
  //                 // this.powerFactorStripLines=[];
  //                 // this.powerFactorStripLines.push(Number(range[0]))
  //                 // this.powerFactorStripLines.push(Number(arcs[0]))
  //                 // this.powerFactorStripLines.push(Number(arcs[1]))
  //                 // this.powerFactorStripLines.push(Number(arcs[2]))
  //                 // this.powerFactorStripLines.push(Number(arcs[3]))
  //                 // this.powerFactorStripLines.push(Number(arcs[4]))
  //                 // this.powerFactorStripLines.push(Number(range[1]))
  //                 // this.emPowerFactorFrequencyData.powerFactorStripLines=this.powerFactorStripLines;

  //             }
  //           }

  //           if(response.movingAvg != undefined){

  //             if(response.movingAvg.length != 0){
  
  //                 this.emPowerFactorMovingAvg = response.movingAvg;
  //                 this.emPowerFactorMovingCount = response.movingCount;
  //             }
  //           }
  //       }
  //     });
  //     // let graphInterval1=setInterval(()=>{
  //     //   if(this.emPowerFactorFrequencyData.length >=1 && 
  //     //     (this.emPowerFactorLineData.length >=1 || this.PowerFactorLineChartColors.length >=1) &&
  //     //     (this.emFrequencyLineData.length >=1 || this.FrequencyLineChartColors.length >=1)
  //     //   ){                  
  //     //     this.powerfactorloading=false;
  //     //     this.trendspowerfactorloading=false;
  //     //     this.trendsfrequencyloading=false;
  //     //     clearInterval(graphInterval1)
  //     //   }
  //     // },2000)
    
  // }

    openEmeterGraphVpfSettingsDialog(metric_type: string, serial_number: string): void {
        // Open Dialog Box with loading state
        const dialogRef = this.dialog.open(DialogGraphscaleVpfSettingsComponent, {
          width: '1050px',
          data: { loading: true } // Initial data with loading state
        });
       
        // Fetch data
        this.getEmeterVpfGraphScaleSettingsDataByID(metric_type, serial_number).then((data: any) => {
          // Prepare the data
          const response = data;
          // Update dialog data
          // console.log(response);
          
          dialogRef.componentInstance.updateData(response);
        }).catch(error => {
          console.error('Error fetching data:', error);
          // Handle error here
        });
      
        // Handle dialog close event
        dialogRef.afterClosed().subscribe(updatedSettings => {
          // console.log(updatedSettings)
          if (updatedSettings) {
    // console.log("==================")
            this.saveVpfSettings(updatedSettings);  
            var currentSettingRequest = updatedSettings[0].metric_type;
            // console.log("saving done", currentSettingRequest)
           
            if (currentSettingRequest === '3PhaseLineVoltageA') {
              let {base_value,orieX_default,orieY_default,orieZ_default,threshold_1,threshold_2,threshold_3,max_value}=updatedSettings[0]
              this.voltageStripLines=[base_value,threshold_1,threshold_2,orieX_default,orieY_default,max_value]
              this.threephaselinevoltageloading = true;
              this.trendsvoltageloading = true;
              setTimeout(() => {
                this.PhaseLineVoltage();
              }, 2000);
            }
          
            if (currentSettingRequest === 'Frequency') {
              let {base_value,orieX_default,orieY_default,orieZ_default,threshold_1,threshold_2,threshold_3,max_value}=updatedSettings[0]
              this.powerFactorStripLines=[base_value,threshold_1,threshold_2,threshold_3,orieY_default,max_value]
              this.powerfactorloading = true;
              this.trendspowerfactorloading = true;
              this.trendsfrequencyloading = true;
              // setTimeout(() => {
              //   this.PowerFactorFrequency();
              // }, 2000);
            }
            // if (currentSettingRequest === 'Frequency') {
            //   console.log('Setting')
            //   let {base_value,orieX_default,orieY_default,orieZ_default,threshold_1,threshold_2,threshold_3,max_value}=updatedSettings[1]
            //   this.frequencyStripLines=[base_value,threshold_1,threshold_2,orieX_default,orieY_default,max_value]
            //   this.powerfactorloading = true;
            //   console.log("+++++++++++++++++")
            //   this.trendspowerfactorloading = true;
            //   this.trendsfrequencyloading = true;
            //   setTimeout(() => {
            //     this.PowerFactorFrequency();
            //   }, 0);
            // }
            if (currentSettingRequest === 'PeakDemand-KVA') {
              let {base_value,orieX_default,orieY_default,orieZ_default,threshold_1,threshold_2,threshold_3,max_value}=updatedSettings[1]
              // this.kwStripLines=[base_value,threshold_1,threshold_2,orieX_default,orieY_default,max_value]
              this.peakdemandloading = true;
              this.trendskwdemandloading = true;
              // setTimeout(() => {
              //   this.PeakDemandKWKVA();
              // }, 2000);
            }
            // Show toast message
            this._snackBar.open('Settings have been saved successfully.', 'Dismiss', {
              duration: 2000,
              horizontalPosition: 'center',
              verticalPosition: 'center' as MatSnackBarVerticalPosition, // Explicitly specify the type
              panelClass: ['custom-snackbar']
            });
          }
        });
      }
}
